import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslationKeyMap } from '../gp-main.i18n';
import { gpCompareRows } from '../gp-sort.util';
import { ViewRow } from '../view-row.model';

@Component({
    selector: 'cmps-gp-grid',
    templateUrl: './gp-grid.component.html',
})
export class GpGridComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    @Input() rows: ViewRow[] = [];

    /** @private */
    _sortColumn = 'nba';

    /** @private */
    _sortOrder = 'desc';

    @Output() wpClick = new EventEmitter<ViewRow>();

    get _sortedRows(): ViewRow[] {
        if (this.rows.length === 0) return [];
        return [...this.rows].sort((a, b) =>
            gpCompareRows(a, b, this._sortColumn, this._sortOrder),
        );
    }

    _trackByRow(_: number, row: ViewRow): number {
        return row.row.userId;
    }

    _onSortClick(column: string): void {
        const order =
            column !== this._sortColumn
                ? 'asc'
                : this._sortOrder === 'asc'
                ? 'desc'
                : 'asc';
        this._sortColumn = column;
        this._sortOrder = order;
    }
}
